'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { isSponsorshipInTransition } from '@sola/shared-utils/supporters/commitments.ts';
import { DepartureAlertTransition } from '../departure-alert-transition/departure-alert-transition.tsx';
import { usePageAlert } from '../page-alert/page-alert-provider.tsx';
import { getDeparturePageAlert } from './departure-alert-page-alert.ts';
import { useDepartureAlert } from './departure-alert.logic.ts';
const DepartureAlertInternal: React.FC<{
  globalId: string;
}> = t0 => {
  const $ = _c(5);
  const {
    globalId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const alertData = useDepartureAlert(globalId);
  let t2;
  bb0: {
    if (!alertData) {
      t2 = undefined;
      break bb0;
    }
    const t3 = `child-bio-departure-${globalId}`;
    let t4;
    if ($[1] !== alertData || $[2] !== t || $[3] !== t3) {
      t4 = getDeparturePageAlert({
        id: t3,
        alertData,
        t
      });
      $[1] = alertData;
      $[2] = t;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t2 = t4;
  }
  const pageAlert = t2;
  usePageAlert(pageAlert);
  return null;
};
export const DepartureAlert: React.FC<{
  globalId: string;
  commitment?: GraphQLCommitment;
}> = t0 => {
  const $ = _c(4);
  const {
    globalId,
    commitment
  } = t0;
  if (isSponsorshipInTransition(commitment)) {
    let t1;
    if ($[0] !== globalId) {
      t1 = <DepartureAlertTransition globalId={globalId} />;
      $[0] = globalId;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== globalId) {
    t1 = <DepartureAlertInternal globalId={globalId} />;
    $[2] = globalId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};